module.exports = angular.module('add-to-list-ctrl', [])
    .controller('addToListFormCtrl',['$rootScope', '$scope', 'canvasService', function ($rootScope, $scope, canvasService) {
        $scope.displayAddListActionOptions = false;
        $scope.displayError = false;
        $scope.descriptionEmpty = false;
        $scope.search = {};
        $scope.$parent.createListName = {};
        $scope.showContactsWarning = false;

        if ($scope.connections.length !== undefined) {
            let now = new Date();

            //Start new Connection obj
            $scope.connections = {
                id:'entry_' + now.getTime(),
                data: {
                    selectedList: [],
                    contactOptions: 'add-contacts-future'
                },
            };
        }

        $scope.$parent.connections = $scope.connections;

        $scope.contactOptions = [
            {
                value: 'all-in-any-future',
                message: $scope.translate('commons.all.subscribers')
            },
            {
                value: 'add-contacts-list',
                message: $scope.translate('commons.existing.subscribers')
            },
            {
                value: 'add-contacts-future',
                message: $scope.translate('commons.new.subscribers')
            }
        ];

        $scope.sortDataList = () => {
            $scope.contactListData = $scope.contactListData.map((i) => {
                if($scope.connections.data.selectedList.indexOf(i.ListId) > -1) {
                    i.selectedItem = true;
                } else {
                    delete i.selectedItem;
                }

                return i;
            });

            Object.assign($scope.contactListData,  _.orderBy($scope.contactListData, ['selectedItem'],['asc']));
        };
        $scope.sortDataList();

        $scope.toggelListItem = function (listItem, $i) {
            if($scope.connections.isDummy) {
                $scope.connections.data.selectedList = [];
                delete $scope.connections.isDummy;
            }

            var index = $scope.connections.data.selectedList.indexOf(listItem);
            if (index > -1) {
                $scope.connections.data.selectedList.splice(index, 1);
                delete $scope.contactListData[$i].selectedItem;
            } else {
                $scope.connections.data.selectedList.push(listItem);
                $scope.contactListData[$i].selectedItem = true;
            }

            Object.assign($scope.contactListData,  _.orderBy($scope.contactListData, ['selectedItem'],['asc']));

            if ($scope.connections.data.selectedList.length) {
                $scope.selectedKey = $scope.translate('commons.editSelection');
            } else {
                $scope.selectedKey = $scope.translate('commons.selectList');
            }
        };

        $scope.setScrollLogic = function(id) {
            $scope.listLoader = false;
            angular.element(
                document.getElementById('contactListContainer' + id)).bind("scroll",
                function () {
                    if(!$scope.listLoader && !$rootScope.stopLoadingList && !$scope.search.list) {
                        $scope.listLoader = true;
                        canvasService.getContactList($rootScope.contactListOffset, 10)
                            .success(function(data) {
                                if(!data.Results.length) {
                                    $rootScope.stopLoadingList = true;
                                }
                                else {
                                    $rootScope.contactListOffset++;
                                    $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(data.Results), 'ListId');
                                    $scope.contactListData = $rootScope.contactListData;
                                    Object.assign($scope.contactListData,  _.orderBy($scope.contactListData, ['selectedItem'],['asc']));
                                }
                                $scope.listLoader = false;
                            })
                            .error(function() {
                                $scope.listLoader = false;
                            })
                    }
                }
            );
        };

        $scope.searching = false;
        $scope.search.search =  (val) => {
            if(val && val.length > 0 && !$scope.searching) {
                $scope.searching = true;
                canvasService.searchContactList(val)
                    .then((res) => {
                        $scope.searching = false;
                        $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(res.data.Results), 'ListId');
                        $scope.contactListData = [];
                        $scope.contactListData = $scope.contactListData.concat(res.data.Results);
                        $scope.sortDataList();
                    })
                    .catch(() => {
                        $scope.searching = false;
                    });
            } else {
                $scope.contactListData = $rootScope.contactListData;
                $scope.sortDataList();
            }
        };

        setTimeout(function() {
            $scope.setScrollLogic($scope.connections.id);
        }, 100);

        // Functionality for add a new list name
        $scope.showCreateListNameModal = () => {
            $scope.$parent.showTriggerPanelModal = false;
            $scope.$parent.showCreateListName = true;
        };

        $scope.$parent.goCreateList = () => {
            if ($scope.$parent.createListName.name === undefined) {
                $scope.$parent.showNewListNameError = true
            }

            if($scope.$parent.createListName.name) {
                $scope.$parent.createListLoader = true;
                canvasService.createContactList($scope.$parent.createListName.name).success(({Results}) => {
                    if(Results.length) {
                        const result = Results[0];
                        const listItem = {
                            ContactCount: 0,
                            ListId: result.ListId,
                            ListName: result.ListName
                        };
                        $scope.contactListData.unshift(listItem);
                        $rootScope.contactListData.unshift(listItem);
                        $scope.toggelListItem(result.ListId, 0);
                        $scope.createList = false;
                        $rootScope.$emit('errorMsg', $scope.translate('common.list.message'), 'confirmation');
                        $scope.$parent.hideAddNewList();
                    }
                    else {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                    }
                }).error(() => {
                    $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                }).finally(function () {
                    $scope.$parent.createListLoader = false;
                });
            }
        };

        $scope.$parent.hideAddNewList = () => {
            $scope.$parent.showTriggerPanelModal = true;
            $scope.isAddToListFormDisplayed = true;
            $scope.$parent.showCreateListName = false;
        };

        $scope.$watch('connections.data.contactOptions', (newVal) => {
            $scope.showContactsWarning = newVal === 'add-contacts-list';
        })
        // End Functionality for add a new list name
    }]);



// WEBPACK FOOTER //
// ./app/controllers/triggerPanel/addToListFormCtrl.js